import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../context/authContext";
import AppBackground from "./background";

interface Props {
  children: React.ReactNode;
}

/**
 * Гард приватных страниц.
 * - loading → пустой фон (можно потом заменить на спиннер).
 * - guest   → редирект на /login; после входа всегда ведём на главный экран (`/`),
 *             а не туда, куда изначально вела ссылка — так удобнее и предсказуемее
 *             для новых пользователей, чем случайно попасть на произвольный внутренний экран.
 * - authed  → показываем содержимое.
 */
export const ProtectedRoute = ({ children }: Props) => {
  const { status } = useAuth();

  if (status === "loading") {
    return (
      <div className="App">
        <AppBackground />
        <header className="App-header"></header>
        <div className="loading-overlay"></div>
      </div>
    );
  }

  if (status === "guest") {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
